module.exports = __webpack_public_path__ + "38fa6dd75ab2e0fe9345aa2101354b5a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-27.png
// module id = 2605
// module chunks = 0